export default "__VITE_ASSET__6e6edd61__"